module.exports = __webpack_public_path__ + "img/trees-icon.113966a5.svg";